import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@core/service/auth.service';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { BenefDetailComponent } from '@shared/components/benef-detail/benef-detail.component';

@Component({
  selector: 'app-search-form-full',
  imports: [FormsModule, CommonModule, BenefDetailComponent],
  templateUrl: './search-form-full.component.html',
  styleUrl: './search-form-full.component.scss'
})
export class SearchFormFullComponent {
  // Form properties
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule';
  input_value: any;
  isLoading = false;
  searchAttempted = false;

  // Beneficiary data
  itemBeneficiare: any = {};

  canEditProfile = false;

  @Output() sendUserInfo = new EventEmitter<any>();
  @Input() beneficiaireAutOselect: any;

  user: any;

  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService
  ) {
    this.user = this.authService.getCurrentUser();
    this.canEditProfile = this.user?.role === 'admin' || this.user?.permissions?.includes('edit_beneficiary');
    this.itemBeneficiare = this.authService.getActiveBeneficiaire();
    this.input_value = this.itemBeneficiare.matricule;
  }

  setMode(mode: string): void {
    this.input_option = mode;
    this.onChangeInputMode();
  }

  onChangeInputMode(): void {
    this.input_value = '';
    this.searchPlaceHolder = this.input_option === 'MAT'
      ? 'Entrez numéro matricule'
      : 'Entrez numéro cnam';

    if (this.searchAttempted) {
      this.resetBeneficiaryData();
    }
  }

  searcheBenef(matricule?: any): void {
    this.isLoading = true;
    this.searchAttempted = true;

    let searchValue = matricule || this.input_value;

    if (matricule) {
      this.input_option = 'MAT';
      this.input_value = matricule;
    }

    if (!searchValue) {
      const messages: { [key: string]: string } = {
        CMU: 'Veuillez renseigner le numéro CMU',
        MAT: 'Veuillez renseigner le numéro matricule',
      };
      const message = messages[this.input_option];
      if (message) {
        this.utilities.showSweetNotification(message, 'error');
        this.isLoading = false;
        return;
      }
    }

    const searchData = this.input_option === 'CMU'
      ? { numero_cnam: searchValue }
      : { matricule: searchValue };

    this.itemBeneficiare = {};

    const request = { is_required_dossier: false, data: searchData };

    this.restClient.post('beneficiaire/search', request).subscribe({
      next: (res: any) => this.handleSearchSuccess(res),
      error: (error) => this.handleSearchError(error)
    });
  }

  private handleSearchSuccess(res: any): void {
    this.isLoading = false;

    if (res && !res['hasError'] && res.item) {
      this.itemBeneficiare = {
        ...res.item,
        is_online: res.item.is_online ?? false,
        display_name: `${res.item.prenom || ''} ${res.item.nom || ''}`.trim()
      };

      this.authService.setActiveBeneficiaire(this.itemBeneficiare);
      this.sendUserInfo.emit(this.itemBeneficiare);
    } else {
      this.handleSearchError(res?.status?.message || 'Aucun bénéficiaire trouvé');
    }
  }

  private handleSearchError(error: any): void {
    this.isLoading = false;
    const errorMessage = typeof error === 'string'
      ? error
      : error?.error?.status?.message || error?.message || 'Erreur lors de la recherche';
    this.utilities.showSweetNotification(errorMessage, 'error');
    this.resetBeneficiaryData();
  }

  private resetBeneficiaryData(): void {
    this.itemBeneficiare = {};
  }

  resetSearch(): void {
    this.input_value = '';
    this.resetBeneficiaryData();
    this.searchAttempted = false;
    this.isLoading = false;
    this.sendUserInfo.emit({});
  }

  get searchModeLabel(): string {
    return this.input_option === 'MAT' ? 'Matricule' : 'CMU';
  }

  get searchModeIcon(): string {
    return this.input_option === 'MAT' ? 'fa-id-card' : 'fa-credit-card';
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.resetBeneficiaryData();

    if (changes['beneficiaireAutOselect']?.currentValue) {
      const activeBeneficiaire = this.authService.getActiveBeneficiaire();
      if (activeBeneficiaire?.matricule) {
        this.searcheBenef(activeBeneficiaire.matricule);
      }
    }
  }
}
